<p-card
  *ngIf="withCard"
  styleClass="very-compact-card p-3">
  <h3 class="m-0">{{ header }}</h3>
  <ng-template [ngTemplateOutlet]="table"></ng-template>
</p-card>

<ng-container *ngIf="!withCard">
  <ng-template [ngTemplateOutlet]="table"></ng-template>
</ng-container>

<ng-template #table>
  <div
    *ngIf="errors && typeErrors === 'string'"
    class="mx-3"
    [class.mb-3]="bankDetails?.length">
    <small class="p-error">
      {{ errors | join }}
    </small>
  </div>
  <crm-table
    *ngIf="bankDetails?.length"
    name="contragentBankDetails"
    [columns]="columns"
    [values]="bankDetails"
    styleClass="p-datatable-sm">
    <ng-template
      #rowTemplate
      let-bankDetail="item"
      let-index="rowIndex">
      <tr *ngIf="toBankDetail(bankDetail) as bankDetail">
        <td>
          <crm-input-text
            [(value)]="bankDetail.name"
            [isError]="$any(errors?.[index]?.['name'])"
            class="w-full"></crm-input-text>
          <small
            *ngIf="errors?.[index]?.['name']"
            class="p-error">
            {{ errors[index]['name'] | join }}
          </small>
        </td>
        <td *ngIf="jurisdiction !== JurisdictionTypeEnum.FOREIGN">
          <crm-bank-auto-complete
            styleClass="w-full"
            class="w-full"
            [inputStyle]="{ width: '100%' }"
            [(selectedBank)]="bankDetail.bank"
            [isError]="$any(errors?.[index]?.['bank'])"
            [banks]="banks"
            (bankSearch)="bankSearch.emit($event)"
            appendTo="body">
          </crm-bank-auto-complete>
          <small
            *ngIf="errors?.[index]?.['bank']"
            class="p-error">
            {{ errors[index]['bank'] | join }}
          </small>
        </td>
        <td>
          <crm-input-text
            [(value)]="bankDetail.checkingAccount"
            [isError]="$any(errors?.[index]?.['checkingAccount'])"
            class="w-full"></crm-input-text>
          <small
            *ngIf="errors?.[index]?.['checkingAccount']"
            class="p-error">
            {{ errors[index]['checkingAccount'] | join }}
          </small>
        </td>
        <td *ngIf="showDefaultBankDetail">
          <p-checkbox
            [(ngModel)]="bankDetail.isDefault"
            (ngModelChange)="setDefaultBankDetail(index, $event)"
            [binary]="true"></p-checkbox>
        </td>
        <td *ngIf="showPaymentsViaBank">
          <p-checkbox
            [(ngModel)]="bankDetail.paymentsViaBank"
            [binary]="true"></p-checkbox>
        </td>
        <td class="max-w-4rem">
          <crm-button
            type="button"
            icon="pi pi-times"
            styleClass="p-button-rounded p-button-danger p-button-text"
            (onClick)="deleteBankDetail(bankDetail)"></crm-button>
        </td>
      </tr>
    </ng-template>
  </crm-table>

  <div
    *ngIf="withCard"
    class="py-3">
    <crm-button
      label="Добавить"
      icon="pi pi-plus"
      styleClass="p-button-text"
      (onClick)="addBankDetail()"></crm-button>
  </div>
</ng-template>
